import { PropsWithChildren, use } from 'react';
import AuthJwtProvider, { AuthJwtContext } from './auth-provider/AuthJwtProvider';
import SocialAuthProvider from './auth-provider/SocialAuthProvider';

const AuthProvider = ({ children }: PropsWithChildren) => {
  return (
    <AuthJwtProvider>
      <SocialAuthProvider>{children}</SocialAuthProvider>
    </AuthJwtProvider>
  );
};

export const useAuth = () => use(AuthJwtContext);

export default AuthProvider;
